module.exports = __webpack_public_path__ + "static/media/Grid.7671e73e.svg";